import { action, observable } from "mobx";
import FinancesService from 'services/FinancesService'
import _ from 'lodash'
import moment from 'moment'

// class Extract {
//     @observable date
//     @observable fk_company
//     @observable pk_extract_entry
//     @observable value

//     constructor(json = {}) {
//         this.date = json.date
//         this.fk_company = json.fk_company
//         this.pk_extract_entry = json.pk_extract_entry
//         this.value = json.value
//     }

// }

class FinancesStore {

  @observable availableToTransfer
  @observable allMoneyInMoip
  @observable notSettled
  @observable unavailable
  @observable extracts = []
  @observable extractLoading = false
  @observable extractItems = []
  @observable loadingExtract = false
  @observable fetchingMoipBalance = false

  @observable previsions = []
  @observable releasedPrevisions = null
  @observable canceledPrevisions = null
  @observable loadingPrevisionAndExtract = false

  @observable extractPrevision = []
  @observable extractFiltered = []
  @observable extractMonth = moment()
  @observable previousBalance = null
  @observable previsionReleased = null
  @observable previsionCancelled = null
  @observable previsionNotReleased = null
  @observable boletoPrevision = null

  @observable monthSake = null
  @observable monthReleased = null
  @observable monthCanceled = null
  @observable monthBalance = null

  @observable paymentModalInfo = {}
  @observable paymentModalInfoLoading = false

  @action
  getMoipBalances() {
    this.fetchingMoipBalance = true
    FinancesService.getMoipBalances()
      .then(res => {
        this.fetchingMoipBalance = false
        this.allMoneyInMoip = this.adjustMoipNumber(res.current)
        this.unavailable = this.adjustMoipNumber(res.unavailable)
        this.notSettled = this.adjustMoipNumber(res.future)

        // the result of this calc could be negative according to moip, if so then use it 0
        const availableToTransfer = this.adjustMoipNumber(res.current - res.unavailable)
        this.availableToTransfer = Math.max(availableToTransfer, 0) // - this.boletoPrevision
      })
      .catch(err => this.fetchingMoipBalance = false)
  }

  @action
  getExtractByMonth() {
    this.extractLoading = true
    return FinancesService.getExtractByMonth()
      .then(res => {
        this.extractLoading = false

        const grouped = _.groupBy(res.data, extract => moment(extract.date, 'YYYY-MM-DD').format('MM'))
        const extractMapped = _.map(grouped, (objs, key) => ({
          extracts: objs,
          totalValue: _.sumBy(objs, extract => Number(extract.value)),
          monthNumber: moment(grouped[key][0].date)
        }));

        this.extracts = _.sortBy(extractMapped, extract => extract.monthNumber.format('MM'))

      })
      .catch(err => console.log(err))
  }

  @action
  transferAvailableMoipBalance(amount, base64) {
    const amountFormatted = Number(amount.toString().replace(/\D/g, ""))

    return FinancesService.transferAvailableMoipBalance(amountFormatted, this.availableToTransfer, base64)
      .then(res => res.data)
      .catch(err => console.log(err))
  }

  getImgOfReceipt(receipt_html) {
    FinancesService.getImgOfReceipt(receipt_html)
  }

  adjustMoipNumber(number) {
    if (!number) return 0

    const arr = number.toString().split('')
    arr.splice(arr.length - 2, 0, '.')
    const formattedNumber = Number(arr.join(''))
    return formattedNumber
  }

  @action
  getExtractOfMonth(startDate, endDate) {
    this.loadingExtract = true
    return FinancesService.getExtractOfMonth({
      startDate: startDate,
      endDate: endDate
    }).then(res => {
      this.extractItems = res.data
      this.loadingExtract = false
    }).catch(err => console.log(err))
  }

  @action
  getCompanyPayments() {
    this.loadingPrevisionAndExtract = true

    return FinancesService.getCompanyPayments().then(async (res) => {
        // Extrato
        this.extractPrevision = _.orderBy(res.extractPrevisions, ['date'], ['asc'])

        // Previsão
        this.previsions = res.previsions
        this.previsionCancelled = res.previsionCancelled
        this.previsionNotReleased = res.previsionNotReleased
        this.previsionReleased = res.previsionReleased
        this.boletoPrevision = res.boletoPrevision
                
        this.filterExtract()
        this.loadingPrevisionAndExtract = false
    })
  }

  @action
  calcPreviousBalance() {
    const previusExtract = this.extractPrevision.filter((ep) => moment(ep.date) < this.extractMonth)

    let sum = 0

    previusExtract.forEach((pe) =>
      pe.items.forEach((i) => {
        if (i.transference === false && i.data.status !== "REFUNDED") {
          sum += Number(i.data.company_amount);
        } else {
          const adjustNumber = this.adjustMoipNumber(i.data.amount)
          sum -= adjustNumber
        }
      }
    ))

    this.previousBalance = parseFloat(sum).toFixed(2)
  }

  @action
  calcMonthCancelled() {
    let sum = 0

    this.extractFiltered.forEach((pe) =>
      pe.items.forEach((i) => {
        if (i.transference === false && i.payment_status === 'REFUNDED') {
          sum += Number(i.data.company_amount);
        }
      }
      ))

    this.monthCanceled = sum.toFixed(2)
  }

  @action
  calcMonthReleased() {
    let sum = 0

    this.extractFiltered.forEach((pe) =>
      pe.items.forEach((i) => {
        if (i.transference === false && i.data.payment_status !== "REFUNDED") {
          sum += Number(i.data.company_amount);
        }
      }))

    this.monthReleased = sum.toFixed(2)
  }

  @action
  calcMonthSake() {
    let sum = 0

    this.extractFiltered.forEach((pe) =>
      pe.items.forEach((i) => {
        if (i.transference === true) {
          const adjustNumber = this.adjustMoipNumber(i.data.amount)
          sum += adjustNumber
        }
      }))

    this.monthSake = sum.toFixed(2)
  }

  @action
  calcMonthBalance() {
    this.monthBalance = this.monthReleased - this.monthSake
  }

  @action
  filterExtract() {
    this.extractFiltered = this.extractPrevision.filter((ep) => this.extractMonth.format("MM YYYY") === moment(ep.date).format("MM YYYY"))

    this.calcMonthCancelled()
    this.calcMonthReleased()
    this.calcMonthSake()
    this.calcPreviousBalance()
    this.calcMonthBalance()
  }

  @action
  goNextMonth() {
    this.extractMonth = this.extractMonth.add(1, 'months')
    this.filterExtract()
  }

  @action
  goBackMonth() {
    this.extractMonth = this.extractMonth.subtract(1, 'months')
    this.filterExtract()
  }

  @action
  getPaymentModalInfo(pkPayment) {
    this.paymentModalInfoLoading = true

    return FinancesService.getPaymentModalInfo({
      pkPayment: pkPayment
    }).then((res) => {
        this.paymentModalInfo = res
        this.paymentModalInfoLoading = false
    })
  }
}



export default new FinancesStore();


// WEBPACK FOOTER //
// ./src/modules/finances/FinancesStore.js